var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.763336 1.33333H1.01933V3.92267C1.01933 5.18067 1.51867 6.38732 2.40867 7.27732C2.68933 7.55799 3.002 7.8 3.338 8C3.002 8.2 2.68933 8.44201 2.40867 8.72268C1.51867 9.61268 1.01933 10.8193 1.01933 12.0773V14.6667H0.666667C0.298667 14.6667 0 14.9653 0 15.3333C0 15.7013 0.298667 16 0.666667 16H10.8607C11.2287 16 11.5273 15.7013 11.5273 15.3333C11.5273 14.9653 11.2287 14.6667 10.8607 14.6667H10.508V12.0773C10.508 10.8193 10.008 9.61268 9.118 8.72268C8.83733 8.44201 8.52467 8.2 8.18867 8C8.52467 7.8 8.83733 7.55799 9.118 7.27732C10.008 6.38732 10.508 5.18067 10.508 3.92267V1.33333H10.9573C11.3253 1.33333 11.624 1.03467 11.624 0.666667C11.624 0.298667 11.3253 0 10.9573 0H0.763336C0.395336 0 0.0966695 0.298667 0.0966695 0.666667C0.0966695 1.03467 0.395336 1.33333 0.763336 1.33333ZM9.17467 1.33333H2.35267V3.92267C2.35267 4.82734 2.712 5.69468 3.35133 6.33468C3.99133 6.97401 4.85867 7.33333 5.76334 7.33333C6.668 7.33333 7.536 6.97401 8.17533 6.33468C8.81533 5.69468 9.17467 4.82734 9.17467 3.92267V1.33333ZM3.35133 9.66532C3.99133 9.02599 4.85867 8.66667 5.76334 8.66667C6.668 8.66667 7.536 9.02599 8.17533 9.66532C8.81533 10.3053 9.17467 11.1727 9.17467 12.0773V14.6667H2.35267V12.0773C2.35267 11.1727 2.712 10.3053 3.35133 9.66532Z",
    fill: "#0078E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobs);
export default __webpack_public_path__ + "static/media/jobs.afa06e24e2a93dee8166d35289c1e6fc.svg";
export { ForwardRef as ReactComponent };